import { identity } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const list = identity;
